import "./layout.scss";
import Navbar from "../../components/navbar/Navbar"
import { Navigate, Outlet } from "react-router-dom";
import { useContext, useEffect } from "react";
import { AuthContext } from "../../context/AuthContext";
import AdminNavbar from "../../components/adminnavbar/AdminNavbar";
import ChatWidget from "../../components/chatwidget/ChatWidget";

function Layout() {
  return (
    // <div>
    //   <Navbar /> {/* Ensure the navbar is included here */}
    //   <Outlet /> {/* Renders child routes */}
    // </div>

    <div className="layout">
      <div className="navbar">
        <Navbar />
      </div>
      <div className="content">
        <Outlet/>
      </div>

      <ChatWidget /> {/* Added here */}
    </div>


  );
}

function RequiredAuth() {
  const{currentUser}=useContext(AuthContext);

  // useEffect(()=>{
  // if (!currentUser){
  //   <Navigate to="/login"/>
  // }
    
  // },[currentUser])


  return (
    !currentUser ?(<Navigate to="/login" />):
    (  
    <div className="layout">
      <div className="navbar">
        <Navbar />
      </div>
      <div className="content">
        <Outlet/>
      </div>

      <ChatWidget /> {/* Added here */}

    </div>
    )
  );

}


function RequiredAdminAuth() {
  const{currentUser}=useContext(AuthContext);

  return (
    !currentUser ?(<Navigate to="/login" />):
    (  
    <div className="layout">
      <div className="adminnavbar">
        <AdminNavbar />
      </div>
      <div className="content">
        <Outlet/>
      </div>
    </div>
    )
  );
}


export { Layout,RequiredAuth,RequiredAdminAuth };
